import { ModbusParam } from "@/types/ModbusParam";
import { Logger } from "@/types/Logger";
import { useCsv } from "./useCsv";

const { readCsvFile } = useCsv();

export function useParams($log: Logger) {
  async function getParamsCsv(
    maybeVersion?: string,
    maybeDeviceId?: string,
  ): Promise<ModbusParam[] | null> {
    const version = maybeVersion ?? "0.0.0.0";
    const deviceId = maybeDeviceId || "PCS_EQDA";
    $log?.info(`version: ${version}`);
    const filename = `./data/params-${deviceId}-${version}-GUI.csv`;
    return readCsvFile<ModbusParam>(filename);
  }

  return {
    getParamsCsv,
  };
}
